import RepresentativeErrorUI from 'pages/Representatives/components/RepresentativeErrorUI/RepresentativeErrorUI';
import { useEditProfileMediaResumeData } from '../../hooks/useEditprofileMediaResumeData';
import {
  EditProfileMediaResumeContainer,
  EditProfileResumeContentListContainer,
} from './EditProfileMediaResume.styles';
import { array_skeletons } from 'pages/Representatives/const/array_skeleton';
import { EditProfileCustomSkeleton } from '../../EditProfile.styles';
import EditProfileMediaResumeHeader from './EditProfileMediaResumeHeader/EditProfileMediaResumeHeader';
import EditProfileMediaResumeContent from './EditProfileMediaResumeContent/EditProfileMediaResumeContent';

const EditProfileMediaResume = () => {
  const { id, attachedResume, hiddenResume, creditsLength, resumeLoading, isError, refetch } =
    useEditProfileMediaResumeData();

  return (
    <EditProfileMediaResumeContainer>
      <EditProfileMediaResumeHeader creditsLength={creditsLength} />
      {resumeLoading ? (
        <EditProfileResumeContentListContainer>
          {array_skeletons.map(() => (
            <EditProfileCustomSkeleton variant="rect" width={'100%'} height={55} />
          ))}
        </EditProfileResumeContentListContainer>
      ) : isError ? (
        <div style={{ margin: '20px 0' }}>
          <RepresentativeErrorUI message="There was a problem getting your Resume" onButtonClick={refetch} />
        </div>
      ) : (
        <EditProfileMediaResumeContent attachedResume={attachedResume} hiddenResume={hiddenResume} profileId={id} />
      )}
    </EditProfileMediaResumeContainer>
  );
};

export default EditProfileMediaResume;
